import { Component, OnInit, HostListener } from '@angular/core';
import { PayOnEmailService } from '../service/pay-on-email.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { MessageService } from '@arc/aureus';
import { PoeDataService } from '../service/poe-data.service';
import { Utility } from '../app.utility';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfigService } from '../../app/service/config.service';
import { MetadataResponse } from '../models/request/MetadataResponse';
import { Metadata } from '../models/request/Metadata';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  largeDialogVisible = false;
  uniqueToken: any;
  isMobileCheckDevice: boolean;
  iframeLoad: { "iframe_pac_loc": string; }[];
  formData: string;
  poeHeader: any;
  poeFooter: any;
  poeContact: any;
  bgColor: string;
  fontColour: string;
  pacURI: string;
  CurrentUrl: string;
  cUrl: string[];
  next_btn: string = "";
  tab: any;
  step: any;
  i: any;
  apiKey: string;
  appKey: any;
  metaData: any;
  pacUrl: any;
  showChild: boolean;
  scrHeight: any;
  scrWidth: any;
  colLength: number = 4;

  constructor(
    private PayOnEmailService: PayOnEmailService,
    private router: Router,
    private route: ActivatedRoute,
    public messageService: MessageService,
    private PoeDataService: PoeDataService,
    public util: Utility,
    private sanitizer: DomSanitizer,
    private configService: ConfigService
  ) {
    let mode: string = this.configService.GetMaintenanceMode();
    if (mode.toLowerCase() === "yes") {
      this.router.navigate(['/maintenance']);
    }
    this.route.firstChild.params.subscribe(
      params => this.uniqueToken = encodeURIComponent(params.uniquetoken));

    this.pacURI = this.configService.GetPacURI();

    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        var currentURL = val.url;
        var splitted = currentURL.split("/");
        if (splitted[1] == 'home')
          this.showTab(0);
        if (splitted[1] == 'pac')
          this.showTab(1);
        if (splitted[1] == 'review')
          this.showTab(2);

      }
    });
  }
  VerifyToken() {
    this.PayOnEmailService.VerifyToken(this.uniqueToken).subscribe(data => {
      if (data.status === 200) {
        // Set Access Token
        this.PoeDataService.SetAccessToken(data.body.accessToken);
        this.GetInitialData(data.body.accessToken);

      } else {
        this.router.navigate(['/errors']);
      }
    },
      error => {
        this.router.navigate(['/errors']);
        console.log(error);
      });
  }
  GetInitialData(accessToken: string) {
    this.PayOnEmailService.GetMetaData(accessToken).subscribe(data => {
      if (data.status === 200) {
        var result = data.body.metadataResponse as MetadataResponse;
        this.PoeDataService.SetInvoices(data.body.documents);
        if (!this.util.isEmpty(result)) {

          this.metaData = result.metaData;
          //white lable settings
          this.poeHeader = (result.header) ? this.sanitizer.bypassSecurityTrustHtml(result.header) : this.sanitizer.bypassSecurityTrustHtml('<div style="background-color: #045b62; text-align: center; padding: 10px;"><img id="" class="img" src="../../../assets/layout/images/logo_u3.png"></div>');
          this.poeFooter = (result.footer) ? this.sanitizer.bypassSecurityTrustHtml(result.footer) : "";
          this.bgColor = (result.themeBackgroundColor) ? result.themeBackgroundColor : '#045b62';
          this.fontColour = (result.themeForegroundColor) ? result.themeForegroundColor : '#ffffff';
          this.PoeDataService.changeTheme(this.bgColor, this.fontColour);
          var parseVal = JSON.parse(this.metaData) as Metadata;
          this.poeContact = (parseVal.POE.POEContact) ? this.sanitizer.bypassSecurityTrustHtml(parseVal.POE.POEContact) : this.sanitizer.bypassSecurityTrustHtml("<h3 style=\"color:red;\">*Contact Information Unavailable*</h3>");
          this.PoeDataService.setPoeMetaData(result);
          this.showChild = true;
        }

      } else {
        this.router.navigate(['/errors']);
      }
    },
      error => {
        this.router.navigate(['/errors']);
        console.log(error);
      });
  }
  ngOnInit() {
    this.CurrentUrl = this.router.url;
    this.cUrl = this.CurrentUrl.split("/");
    this.pacUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.pacURI}home/${this.uniqueToken}`);
    this.VerifyToken();
  }

  showTab(n) {
    this.tab = document.getElementsByClassName("tab");
    this.tab[0].style.display = "block";
    this.fixStepIndicator(n)
  }

  fixStepIndicator(n) {
    debugger;
    this.i, this.step = document.getElementsByClassName("step");
    for (this.i = 0; this.i < n; this.i++) {
      this.step[this.i].className += " is-done";
      let classNameList = (this.step[this.i].className).split(" ");
      if (classNameList.includes("current")) {
        const index = classNameList.indexOf("current");
        if (index > -1) {
          classNameList.splice(index, 1);
        }
        this.step[this.i].className = classNameList.join(" ");
      }
    }
    this.step[n].className += " is-done current";

  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;

    console.log(this.scrWidth)
    if (this.scrWidth > 1000) {
      this.colLength = 3;

    } else {
      this.colLength = 4;
    }
  }

}
